import React, { createContext, useState } from 'react'

export const SitesModalContext = createContext()

export const SitesModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [siteData, setSite] = useState(null)

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  return (
    <SitesModalContext.Provider value={{ isModalOpen, toggleModal, siteData, setSite }}>
      {children}
    </SitesModalContext.Provider>
  )
}

export default SitesModalProvider
